module.exports = __webpack_public_path__ + "static/media/kucuncehmingxibiao.83e5ff3b.png";